import {CardPanel} from "../../../stemjs/src/ui/CardPanel.jsx";
import {UI} from "../../../stemjs/src/ui/UIBase.js";
import {MinRanking} from "../../../csacontent/js/GlobalRatings.jsx";
import {Link} from "../../../stemjs/src/ui/primitives/Link.jsx";


export class LeaderboardPanel extends CardPanel {
    getTitle() {
        return UI.T("Leaderboard");
    }

    render() {
        return [
            <MinRanking style={{fontSize: "0.9em", padding: "0 !important", borderTop: "0", borderBottom: "1px solid #ddd",}}/>,
            <div style={{textAlign: "center", height: "32px", lineHeight: "32px", padding: "0 !important",}}>
                <Link href={"/ratings/"} value={UI.T("See full leaderboard")}/>
            </div>];
    }
}